import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {WebsiteService} from "../../website.service";
import {FormControl, FormGroup} from "@angular/forms";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {TagsListDialogComponent} from "../tags-list-dialog/tags-list-dialog.component";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-add-tag-dialog',
    templateUrl: 'add-tag-dialog.component.html',
    styleUrls: ['add-tag-dialog.component.scss'],
    standalone: false
})
export class AddTagDialogComponent extends DialogComponent<null, boolean> implements OnInit {
  public addTagForm: FormGroup;
  public serverErrors: any;
  public loading: boolean;
  public isMobile: boolean;
  @Input() domainIds?: any;
  @Input() hideBackButton?: boolean;

  constructor(
    private _dialogService: DialogService,
    private _websiteService: WebsiteService,
    private _store: Store<fromStore.DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 991;
    this.addTagForm = new FormGroup({
      'tagTitle': new FormControl(""),
    });
  }

  public addTag(): void {
    this.loading = true;
    this._websiteService.addUserTag(this.addTagForm.controls['tagTitle'].value)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if ( response.success ) {
          this._store.dispatch( new fromStore.LoadWebsiteTags() );
          this.backToList();
        }
        else {
          this.loading = false;
          this.serverErrors = response.message;
        }
      });
  }

  public backToList(): void {
    this.close();
    this._dialogService.addDialog(TagsListDialogComponent, {
      addedTag: this.addTagForm.controls['tagTitle'].value,
      domainIds: this.domainIds
    });
  }

}
